import { Block } from "utils/types";

export function getCompactIntervals(blocks: Block[]) {
  const intervals = blocks
    .map(({ block, time, reservations }) => {
      const groups = reservations.filter(({ guests }) => guests > 0);
      const sizes = new Map<number, number>();
      groups.forEach(({ guests }) =>
        sizes.set(guests, (sizes.get(guests) || 0) + 1)
      );
      return {
        block,
        time,
        groups: groups.length,
        guests: groups.reduce((total, group) => total + group.guests, 0),
        sizes: Array.from(sizes, ([guests, count]) => ({ guests, count })).sort(
          (a, b) => a.guests - b.guests
        ),
      };
    })
    .filter(({ groups }) => groups > 0);

  const totalGroups = intervals.reduce(
    (total, interval) => total + interval.groups,
    0
  );
  return totalGroups > 20 && intervals.length <= 3 ? intervals : null;
}
